import type React from "react";
import { createUseStyles } from "react-jss";
import classnames from "classnames";

import { commonStyles } from "@/base/components/Global/Skeleton/commonStyles";

const BLOCK_HEIGHT = 177;
const BLOCK_BIG_HEIGHT = 221;
const BLOCK_WIDTH = 163;

const useStyles = createUseStyles(({ color, spacing, borderRadius }) => ({
  ...commonStyles,
  skeletonBlock: {
    height: BLOCK_HEIGHT,
    minWidth: BLOCK_WIDTH,
    borderRadius: borderRadius.l,
    background: color.skeletonElementBg,
    position: "relative",
    overflow: "hidden",

    "&:after": {
      content: "''",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      position: "absolute",
      backgroundImage: color.skeletonElementShimmer,
      animation: "$shimmer 1.5s infinite",
      overflow: "hidden",
    },
  },
  skeletonBlockBig: {
    height: BLOCK_BIG_HEIGHT,
  },
  mobileContainer: {
    display: "flex",
    flexDirection: "column",
    paddingTop: 32,
    paddingBottom: 60,
    gap: spacing.xxl,
  },
  mobileBlockContainer: {
    display: "flex",
    gap: spacing.xxl,
    justifyContent: "center",
  },
  mobileCol: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.xxl,
    width: "100%",
  },
  headerSkeleton: {
    height: 28,
    width: 120,
    background: color.skeletonElementBg,
    borderRadius: 50,
    position: "relative",
    overflow: "hidden",
    marginLeft: spacing.xl,

    "&:after": {
      content: "''",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      position: "absolute",
      backgroundImage: color.skeletonElementShimmer,
      animation: "$shimmer 1.5s infinite",
      overflow: "hidden",
    },
  },
  desktopContainer: {
    display: "flex",
    flexDirection: "row",
    gap: spacing.xxl,
  },
}));

const MenuBlockMobileSkeleton: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.mobileContainer}>
      <div className={classes.headerSkeleton} />
      <div className={classes.mobileBlockContainer}>
        <div className={classes.mobileCol}>
          <div
            className={classnames(
              classes.skeletonBlock,
              classes.skeletonBlockBig,
            )}
          />
          <div className={classes.skeletonBlock} />
        </div>
        <div className={classes.mobileCol}>
          <div className={classes.skeletonBlock} />
          <div
            className={classnames(
              classes.skeletonBlock,
              classes.skeletonBlockBig,
            )}
          />
        </div>
      </div>
    </div>
  );
};

const MenuBlockDesktopSkeleton: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.desktopContainer}>
      {Array.from({ length: 5 }).map((_, idx) => (
        <div key={idx} className={classes.skeletonBlock} />
      ))}
    </div>
  );
};

export { MenuBlockDesktopSkeleton, MenuBlockMobileSkeleton };
